<life-di-nav></life-di-nav>

<div class="container-fulid text-center overflow-hidden" style="padding-top: 50px;">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1>
        ลงชื่อเข้าใช้
      </h1>
      <form [formGroup]="loginForm" (keydown.enter)="login()">
        <div class="form-group row">
          <label for="emailLogin" class="col-md-3 col-form-label text-md-right">อีเมล</label>
          <div class="col-md-6">
            <input type="email" class="form-control" id="emailLogin" formControlName="email" autocomplete="off">
          </div>
          <!-- start เช็คความถูกต้องของ email -->
          <div *ngIf="checkEmail.dirty && checkEmail.errors?.pattern !== null">
            <label style="margin-top: 10px;" *ngIf="!checkEmail.value === false" class="text-danger">✖</label>
            <label style="margin-top: 10px;" *ngIf="!checkEmail.value === true" class="text-danger"></label>
          </div>
          <div *ngIf="checkEmail.dirty && checkEmail.errors?.pattern === null">
            <label style="margin-top: 10px;" class="text-success">✔</label>
          </div>
          <!-- end เช็คความถูกต้องของ email -->
        </div>
        <div class="form-group row">
          <label for="passwordLogin" class="col-md-3 col-form-label text-md-right">รหัสผ่าน</label>
          <div class="col-md-6">
            <input [type]="passwordType ? 'text' : 'password'" class="form-control" id="passwordLogin" formControlName="password"
              autocomplete="off">
            <span toggle="#passwordLogin" class="toggle-password">
              <a>
                <img src="../../../assets/dark-visibility.png" id="toggle-eye" alt="visibility" (click)="toggle()">
              </a>
            </span>
            <!-- <input type="password" class="form-control" id="passwordLogin" formControlName="password"
              autocomplete="off"> -->
          </div>
          <!-- start hide sm xs -->
          <label class="d-none d-xl-block d-lg-block d-xl-none d-md-block d-lg-none justify-content-center text-danger"
            style="margin-top: 10px;"><a href="/forgotPassword">ลืมรหัสผ่าน</a></label>
          <!-- end hide sm xs -->
        </div>
        <!-- start show sm xs -->
        <div class="row d-block d-sm-none d-none d-sm-block d-md-none">
          <label class="justify-content-center text-danger"><a href="/forgotPassword">ลืมรหัสผ่าน</a></label>
        </div>
        <!-- end show sm xs -->
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div *ngIf="this.errorMsg !== null">
              <span class="text-danger">{{errorMsg}}</span>
            </div>
            <lifedi-btn lable="ลงชื่อเข้าใช้" *ngIf="!loginForm.valid" [disabled]="!loginForm.valid"
              customStyle="width: 100%;">
            </lifedi-btn>
            <lifedi-btn lable="ลงชื่อเข้าใช้" *ngIf="loginForm.valid" (click)="login()"
              customStyle="color:white; background-color: #414A6B; width: 100%;">
            </lifedi-btn>
          </div>
        </div>
      </form>
      <hr width="100%">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <lifedi-btn lable="เข้าสู่ระบบด้วย Facebook"
            customStyle="color:white; background-color: #3B5998; width: 100%;" (click)="loginWithFb()"></lifedi-btn>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <lifedi-btn lable="สร้างบัญชี" customStyle="color:white; background-color: #DE5C8E; width: 100%;"
            routerLink="/register">
          </lifedi-btn>
        </div>
      </div>
    </div>
  </div>
</div>
